import React, { createElement } from 'react';
import { Link } from 'react-router-dom';
import { Footer } from '../components/Footer';
import { Helmet } from 'react-helmet-async';
export function ContestPage() {
  return <>
      <Helmet data-id="element-151">
        <title data-id="element-152">$10K Hit Game Contest - Fifth Door</title>
        <meta name="description" content="Create a hit game on Fifth Door. Reach 100,000 players and win $10,000." data-id="element-153" />
        <link rel="preconnect" href="https://fonts.googleapis.com" data-id="element-154" />
        <link rel="preconnect" href="https://fonts.gstatic.com" crossOrigin="anonymous" data-id="element-155" />
        <link href="https://fonts.googleapis.com/css2?family=Bungee&family=Bricolage+Grotesque:wght@400;500;600;700&family=Instrument+Sans:wght@400;500;600;700&display=swap" rel="stylesheet" data-id="element-156" />
        <script data-id="element-157">
          {`
            !function(t,e){var o,n,p,r;e.__SV||(window.posthog && window.posthog.__loaded)||(window.posthog=e,e._i=[],e.init=function(i,s,a){function g(t,e){var o=e.split(".");2==o.length&&(t=t[o[0]],e=o[1]),t[e]=function(){t.push([e].concat(Array.prototype.slice.call(arguments,0)))}}(p=t.createElement("script")).type="text/javascript",p.crossOrigin="anonymous",p.async=!0,p.src=s.api_host.replace(".i.posthog.com","-assets.i.posthog.com")+"/static/array.js",(r=t.getElementsByTagName("script")[0]).parentNode.insertBefore(p,r);var u=e;for(void 0!==a?u=e[a]=[]:a="posthog",u.people=u.people||[],u.toString=function(t){var e="posthog";return"posthog"!==a&&(e+="."+a),t||(e+=" (stub)"),e},u.people.toString=function(){return u.toString(1)+".people (stub)"},o="init yi Fr Mr mi Rr Or capture Li calculateEventProperties Dr register register_once register_for_session unregister unregister_for_session zr getFeatureFlag getFeatureFlagPayload isFeatureEnabled reloadFeatureFlags updateEarlyAccessFeatureEnrollment getEarlyAccessFeatures on onFeatureFlags onSurveysLoaded onSessionId getSurveys getActiveMatchingSurveys renderSurvey displaySurvey canRenderSurvey canRenderSurveyAsync identify setPersonProperties group resetGroups setPersonPropertiesForFlags resetPersonPropertiesForFlags setGroupPropertiesForFlags resetGroupPropertiesForFlags reset get_distinct_id getGroups get_session_id get_session_replay_url alias set_config startSessionRecording stopSessionRecording sessionRecordingStarted captureException loadToolbar get_property getSessionProperty Nr jr createPersonProfile Ur Tr Hr opt_in_capturing opt_out_capturing has_opted_in_capturing has_opted_out_capturing get_explicit_consent_status is_capturing clear_opt_in_out_capturing Ar debug L Lr getPageViewId captureTraceFeedback captureTraceMetric $r".split(" "),n=0;n<o.length;n++)g(u,o[n]);e._i.push([i,s,a])},e.__SV=1)}(document,window.posthog||[]);
            posthog.init('phc_jETIRcaQQ5wwKvb9mxnRwHnNeXlgXBbTtVWc0NYToYa', {
              api_host: 'https://us.i.posthog.com',
              defaults: '2025-05-24',
              person_profiles: 'identified_only'
            })
          `}
        </script>
      </Helmet>

      <main className="w-full relative isolate overflow-x-hidden min-h-screen" style={{
      backgroundColor: '#074030'
    }} data-id="element-158">
        {/* Background Effects */}
        <div className="absolute inset-0 pointer-events-none -z-10" style={{
        backgroundImage: `
              linear-gradient(to right, rgba(255, 255, 255, 0.1) 1px, transparent 1px),
              linear-gradient(to bottom, rgba(255, 255, 255, 0.1) 1px, transparent 1px)
            `,
        backgroundSize: '30px 30px',
        backgroundPosition: '0 0'
      }} data-id="element-159" />

        <div className="absolute inset-0 pointer-events-none -z-10" style={{
        backgroundImage: 'url(https://cdn.magicpatterns.com/uploads/bonQpX7FQKEhKvnQfRNJtT/noise-background.png)',
        backgroundRepeat: 'repeat',
        backgroundSize: '200px 200px',
        opacity: 0.24
      }} data-id="element-160" />

        {/* Logo - Top Left Absolute Position */}
        <div className="absolute top-8 left-8 z-20" data-id="element-161">
          <Link to="/" className="flex items-center gap-3" data-id="element-162">
            <img src="https://cdn.magicpatterns.com/uploads/8dB8M4GqHB66FgPhzt2tyW/Group_44.png" alt="Fifth Door Logo" className="h-8 w-auto object-contain brightness-0 invert" data-id="element-163" />
            <span className="text-white text-lg" style={{
            fontFamily: 'Bungee, sans-serif'
          }} data-id="element-164">
              FIFTH DOOR
            </span>
          </Link>
        </div>

        {/* Content */}
        <div className="relative z-10 px-6 py-20 md:py-32 max-w-5xl mx-auto text-center" data-id="element-165">
          <div className="flex justify-center mb-8" data-id="element-166">
            <div className="inline-flex items-center px-8 md:px-10 py-2 rounded-full" style={{
            backgroundColor: 'rgba(255, 255, 255, 0.1)',
            backdropFilter: 'blur(4px)'
          }} data-id="element-167">
              <p className="text-sm font-normal" style={{
              color: 'rgba(255, 255, 255, 0.5)',
              fontFamily: "'Instrument Sans', sans-serif"
            }} data-id="element-168">
                The Fifth Door Creator Fund
              </p>
            </div>
          </div>

          <h1 className="text-[50px] md:text-[74px] mb-6" style={{
          fontFamily: 'Bungee, sans-serif',
          color: 'white',
          lineHeight: '1.1'
        }} data-id="element-169">
            100K PLAYERS.
            <br data-id="element-170" />
            $10,000 REWARD.
          </h1>

          <p className="text-xl md:text-2xl leading-relaxed mb-12 text-white/80 max-w-3xl mx-auto" style={{
          fontFamily: "'Instrument Sans', sans-serif"
        }} data-id="element-171">
            We're looking for the next big hit. Build a game for Reddit on Fifth
            Door without writing a single line of code. If your game reaches
            100,000 players, we'll pay you $10,000.
          </p>

          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center mb-24 w-full sm:px-0" data-id="element-172">
            <a href="https://play.fifthdoor.com/create?utm_source=reddit" target="_blank" rel="noopener noreferrer" className="w-[90%] sm:w-auto px-8 py-3.5 rounded-full font-semibold text-[15px] transition-all duration-300 hover:opacity-90 hover:scale-105 flex items-center justify-center gap-2" style={{
            backgroundColor: 'white',
            color: '#074030',
            fontFamily: "'Instrument Sans', sans-serif"
          }} data-id="element-173">
              Create a Game
            </a>
          </div>

          {/* Steps Grid */}
          <div className="grid md:grid-cols-3 gap-8 text-left" data-id="element-174">
            <div className="p-8 rounded-2xl border border-white/10 bg-white/5 backdrop-blur-sm hover:bg-white/10 transition-colors duration-300" data-id="element-175">
              <div className="text-4xl mb-6" data-id="element-176">🛠️</div>
              <h3 className="text-2xl font-bold mb-4 text-white" style={{
              fontFamily: "'Instrument Sans', sans-serif"
            }} data-id="element-177">
                1. Build
              </h3>
              <p className="text-white/70 leading-relaxed" style={{
              fontFamily: "'Instrument Sans', sans-serif"
            }} data-id="element-178">
                Use our intuitive no-code tools to bring your game idea to life
                in minutes. No technical experience required.
              </p>
            </div>

            <div className="p-8 rounded-2xl border border-white/10 bg-white/5 backdrop-blur-sm hover:bg-white/10 transition-colors duration-300" data-id="element-179">
              <div className="text-4xl mb-6" data-id="element-180">🚀</div>
              <h3 className="text-2xl font-bold mb-4 text-white" style={{
              fontFamily: "'Instrument Sans', sans-serif"
            }} data-id="element-181">
                2. Publish
              </h3>
              <p className="text-white/70 leading-relaxed" style={{
              fontFamily: "'Instrument Sans', sans-serif"
            }} data-id="element-182">
                Publish your game instantly on Reddit. Share it with your
                community.
              </p>
            </div>

            <div className="p-8 rounded-2xl border border-white/10 bg-white/5 backdrop-blur-sm hover:bg-white/10 transition-colors duration-300" data-id="element-183">
              <div className="text-4xl mb-6" data-id="element-184">💰</div>
              <h3 className="text-2xl font-bold mb-4 text-white" style={{
              fontFamily: "'Instrument Sans', sans-serif"
            }} data-id="element-185">
                3. Win
              </h3>
              <p className="text-white/70 leading-relaxed" style={{
              fontFamily: "'Instrument Sans', sans-serif"
            }} data-id="element-186">
                Hit 100k unique players on your game and claim your $10,000
                prize. It's really that simple.
              </p>
            </div>
          </div>
        </div>
      </main>

      <Footer data-id="element-187" />
    </>;
}